import {
  type UseHierarchicalMenuProps,
  useHierarchicalMenu,
} from "react-instantsearch";

import { semanticColor } from "@/shared-web.ui/styles";
import { Badge } from "@/shared-web.ui/ui.badge";
import { Text } from "@/shared-web.ui/ui.text";
import { cn } from "@/shared-web.ui/util.cn";

type HierarchicalListProps = {
  refine: (val: string) => void;
  className?: string;
} & Pick<
  ReturnType<typeof useHierarchicalMenu>,
  "createURL" | "items"
>;
const HierarchicalList = (props: HierarchicalListProps) => {
  const {
    items,
    createURL,
    refine,
    className,
  } = props;

  if (items.length === 0) {
    return null;
  }

  return (
    <ul className={cn(
      "py-1",
      className,
    )}
    >
      {items.map((item) => {
        return (
          <li key={item.value}>
            <button
              type="button"
              onClick={(event) => {
                refine(item.value);
              }}
              className="flex items-baseline gap-2"
            >
              <Text
                semanticColor={item.isRefined ? "accent" : undefined}
                weight={
                  item.isRefined
                    ? "bold"
                    : "regular"
                }
                size="2"
              >
                {item.label}
              </Text>
              <Badge
                size="1"
                variant="surface"
                color={
                  item.isRefined
                    ? semanticColor.accent
                    : "gray"
                }
              >
                {item.count}
              </Badge>
            </button>
            {item.data && (
              <HierarchicalList
                items={item.data}
                refine={refine}
                createURL={createURL}
                className="pl-4"
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

const HierarchicalMenu = (props: UseHierarchicalMenuProps) => {
  const {
    items,
    refine,
    canToggleShowMore,
    toggleShowMore,
    isShowingMore,
    createURL,
  } = useHierarchicalMenu(props);

  return (
    <>
      <HierarchicalList
        items={items}
        refine={refine}
        createURL={createURL}
      />
      {props.showMore && (
        <button
          type="button"
          disabled={!canToggleShowMore}
          onClick={toggleShowMore}
        >
          {isShowingMore ? "Show less" : "Show more"}
        </button>
      )}
    </>
  );
};

export { HierarchicalMenu };
